import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);


const member_api = 'emc-api-server.eilis-ai.com';

/* eslint-disable */
const store = new Vuex.Store({
    state: {
        uid: '',
        userName: '',
        lastLogin: '',
        pageDetail: {
            name: '',
            logo: '',
            ratio: 50,
            expRatio: '',
            taxid: '23055068',
            undotax: '23055068',
            type: 'typeC',
            store: {}
        },
        menus: {},
        workFlows: {}
    },
    getters: {
        lastlogin: state => state.lastLogin,
        userid: state => state.uid,
        menus: state => state.menus,
        username: state => state.userName,
        pageDetail: state => state.pageDetail,
        workFlows: state => state.workFlows
    },
    actions: {
        fetchPicSeeShort({ }, payload) {
            const apiUrl = 'https://api.pics.ee/v1/links/?access_token=efa3225b2643accae33d0ba8509de72c5bfaeaa8';
            const postData = {
                url: payload.url,
                externalId: 'customer_test_1',
            };
            return axios.post(apiUrl, postData)
                .then(response => response.data.data.picseeUrl)
                .catch(() => undefined);
        },
        getNotReceivedToken({ commit, store }, contents) {
            const apiUrl = `https://${member_api}/getNotReceivedToken`;
            return axios.post(apiUrl, contents).then((res) => {
                return res;
            });
        },
        saveNotReceivedLink({ commit, store }, contents) {
            const apiUrl = `https://${member_api}/saveNotReceivedLink`;
            return axios.post(apiUrl, contents).then((res) => {
                return res;
            });
        },
        saveUserDetailToReceiver({ commit, store }, contents) {
            const apiUrl = `https://${member_api}/saveUserDetailToReceiver`;
            return axios.post(apiUrl, contents).then((res) => {
                return res;
            });
        },
        getStoreList({ commit, store }, contents) {
            const apiUrl = `https://${member_api}/getStoreList`;
            return axios.post(apiUrl, {
                Service: contents.service,
                Auth: contents.auth
            }).then((res) => {
                return res;
            });
        },
        getCommentAndRate({ commit, store }, contents) {
            const apiUrl = `https://${member_api}/getPageRate`;
            const postData = {
                Service: contents.service,
                Auth: contents.auth,
                Store: contents.store
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        // 查詢訊息
        getSuccessMessage({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getSuccessMessage`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Type: payload.type
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res.data.Message;
                });
        },
        // 設定訊息
        setSuccessMessage({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/setSuccessMessage`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Type: payload.type,
                Message: payload.msg
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        // 更新帳號資料
        updateAccount({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/updateAccount`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                UpdateData: payload.content
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        // 取得卡片
        getAllWorkFlow({ commit, state }, payload) {
            const api_url   = 'https://api.eilis-ai.com/functional/GetWorkFlow'
            const post_data = {
                PageID: payload,
                Name: 'All',
            }
            return axios.post(api_url, post_data)
                .then((response) => {
                    if (response.data.WorkFlow != null) {
                        return response.data.WorkFlow
                    }
                })
        },
        // 查詢用戶點數
        getPoints({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getUserData`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Phone: payload.phone
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res.data;
                });
        },
        // 資料 query
        dbDataInquire({ commit, state }, payload) {
            const api_url   = 'https://api-linebiz.eilis-ai.com/app/DBDataInquire'
            const post_data = {
                Path: payload.path,
                ChildPath: payload.childPath
            };
            return axios.post(api_url, post_data)
                .then((response) => {
                    if (response.data != null) {
                        return response.data;
                    }
                })
        },
        // 取得藍色選單 LINE
        queryMenuLINE({ commit, state }, payload) {
            const api_url   = 'https://api-linebiz.eilis-ai.com/app/DBDataInquire'
            const post_data = {
                Path: 'Eilis-Clients/',
                ChildPath: `${payload}/Menu`
            };
            return axios.post(api_url, post_data)
                .then((response) => {
                    commit('getMenus', { menuData: response.data, auth: payload });
                })
        },
        // 取得卡片 LINE
        getAllWorkFlowLINE({ commit, state }, payload) {
            const api_url   = 'https://api-linebiz.eilis-ai.com/app/DBDataInquire'
            const post_data = {
                Path: 'Eilis-Clients/',
                ChildPath: `${payload}/WorkFlow`
            };
            return axios.post(api_url, post_data)
                .then((response) => {
                    if (response.data != null) {
                        commit('getWorkFlows', { auth: payload, cards: response.data })
                        return response.data
                    } 
                    else {
                        return {
                            contents: state.CardContent,
                            card_id: null,
                        }
                    }
                })
        },
        // 取得藍色選單 LINE
        getBlueEach({ commit, state }, payload) {
            const api_url   = 'https://api-linebiz.eilis-ai.com/app/DBDataInquire'
            const post_data = {
                Path: 'Eilis-Clients/',
                ChildPath: `${payload}/Menu/`
            };
            return axios.post(api_url, post_data)
                .then((response) => {
                    return response.data;
                })
        },
        // 取得藍色選單內容
        getBlueMenu({ commit, state }, payload) {
            const apiUrl   = 'https://api.eilis-ai.com/functional/GetBlueMenu';
            const postData = {
                PageID: payload.auth,
                Title: !payload.reply ? '公版主選單' : payload.reply,
            };
            return axios.post(apiUrl, postData)
                .then((response) => {
                    return response.data
                })
        },
        getBlueMenuBeta({ commit, state }, payload) {
            const apiUrl = 'https://api-eilis-server-v2.herokuapp.com/functional/getBlueContent';
            const postData = {
                PageID: payload,
            }
            return axios.post(apiUrl, postData)
                .then((response) => {
                    if (response.data && response.data.MenuData) {
                        commit('getMenus', { menuData: response.data.MenuData, auth: payload });
                    }
                })
        },
        // 取得藍色選單
        getBlue({ commit, state }, payload) {
            const api_url   = 'https://api-eilis-server-v2.herokuapp.com/functional/getBlue'
            const post_data = {
                PageID: payload,
            }
            return axios.post(api_url, post_data)
                .then((response) => {
                    return response.data
                })
        },
        lineUserBroadcast({ commit, state }, payload) {
            const apiUrl = `https://api-broadcast.eilis-ai.com/LINE/orderBroadcast`;
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res.data;
                })
        },
        FBUserBroadcast({ commit, state }, payload) {
            const apiUrl = `https://api-broadcast.eilis-ai.com/FB/verBroadcast`;
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res.data;
                })
        },
        checkAccount({ commit, state }, payload) {
            const apiUrl   = `https://${member_api}/checkAccount`;
            const postData = {
                Service: payload.Service,
                Auth: payload.Auth
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    if (res.data.Detail) {
                        commit('getPageDetail', res.data.Detail);
                    }
                    return res.data.Detail;
                });
        },
        addUserTag({ commit, state }, payload) {
            const apiUrl   = `https://${member_api}/createTag`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                UserPhone: payload.phone,
                Tag: payload.addTag,
                BindServ: payload.bindServ
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data
            })
        },
        createTags({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/createTags`;
            const postData = {
                service: payload.service,
                auth: payload.auth,
                phoneList: payload.phone,
                tag: payload.tag,
                bindServ: payload.bindServ
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data
            })
        },
        getTagUser({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getTagUser`;
            const postData = {
                service: payload.service,
                auth: payload.auth,
                tagName: payload.tagName
            }
            return axios.post(apiUrl, postData).then((res) => {
                return res
            })
        },
        removeTags({ commit, state }, payload) {
            const apiUrl   = `https://${member_api}/removeTags`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Token: payload.token,
                Tag: payload.deletedTag,
                Sync: payload.sync
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data
            })
        },
        getMemberNum({ commit, state }, payload) {
            const apiUrl   = `https://${member_api}/getMemberNum`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data
            })
        },
        // 取得主管理員
        getPageAdmin({ commit, state }, payload) {
            const apiUrl   = 'https://api.eilis-ai.com/functional/GetPageAdmin';
            const postData = {
                PageID: payload.auth
            }
            return axios.post(apiUrl, postData).then((res) => {
                return res.data;
            })
        },
        // 取得帳單
        getBilling({ commit, state }, payload) {
            const apiUrl   = `https://${member_api}/getPhoneVer`;
            const postData = {
                service: payload.service,
                auth: payload.auth,
                year: payload.year
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res.data;
                });
        },
        // 取得分眾列表
        getAllTags({ commit, state }, payload) {
            const apiUrl   = `https://${member_api}/readTags`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Phone: payload.phone
            }
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res.data;
                });
        },
        // ----------------------------------------------
        // 預定功能專區
        updateUserStatus({ commit, state }, payload) {
            const apiUrl   = `https://${member_api}/updateUserStatus`;
            const postData = {
                service: payload.service,
                auth: payload.auth,
                calendarId: payload.calendarId,
                eventId: payload.eventId,
                userData: payload.userData
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        // 取得活動細節
        getEventDetail({ commit, state }, payload) {
            const apiUrl   = `https://${member_api}/getEventDetail`;
            const postData = {
                service: payload.service,
                auth: payload.auth,
                eventId: payload.eventId
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        // 刪除活動
        deleteEvent({ commit, state }, payload) {
            const apiUrl   = `https://${member_api}/deleteEvent`;
            const postData = {
                service: payload.service,
                auth: payload.auth,
                calendarId: payload.calendarId,
                eventId: payload.eventId,
                replyMsg: payload.removeMsg
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        // ---------------------------------------------
        // 廣播專區
        getBroadcastDetail({ commit, state }, payload) {
            const apiUrl   = 'https://api.eilis-ai.com/functional/GetBroadcastDetail';
            const postData = {
                UserID: payload.pageAdmin,
                PageID: payload.auth,
                Tag: null
            }
            return axios.post(apiUrl, postData).then((res) => {
                return res.data;
            })
        },
        broadcast({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/broadcast`;
            return axios.post(apiUrl, payload).then((res) => {
                return res;
            })
        },
        scheduleBroadcast({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/scheduleBroadcast`;
            return axios.post(apiUrl, payload).then((res) => {
                return res;
            })
        },
        getSchedule({ commit, state }, payload) {
            const apiUrl   = `https://${member_api}/getSchedule`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res;
            })
        },
        getBroadcastPoint({ commit, state }, payload) {
            const apiUrl   = `https://${member_api}/getBroadcastPoint`;
            return axios.post(apiUrl, payload).then((res) => {
                return res;
            })
        },
        broadcastRecord({ commit, state }, payload) {
            const apiUrl   = `https://${member_api}/broadcastRecord`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res;
            })
        },
        broadcastRecordByTime({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getBroadcastByTime`;
            return axios.post(apiUrl, payload).then((res) => {
                return res;
            })
        },
        removeBroadcasts({ commit, state }, payload) {
            const apiUrl   = `https://${member_api}/removeBroadcast`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                RemoveID: payload.removeId
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res;
            })
        },
        removeSchedules({ commit, state }, payload) {
            const apiUrl   = `https://${member_api}/removeSchedule`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Keys: payload.removeId
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res;
            })
        }, 
        updateEvent({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/updateEvent`;
            return axios.post(apiUrl, payload).then((res) => {
                return res;
            })
        },
        // ---------------------------------------------
        // 共用管理員
        getAccountDetail({ commit, state }, payload) {
            const apiUrl   = 'https://firebase-member-node.herokuapp.com/users/getAccountDetail';
            const postData = {
                Service: (payload.service === 'FB') ? 'fb' : 'line',
                Auth: payload.auth
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res;
            })
        },
        getUserByEmail({ commit, state }, payload) {
            const apiUrl   = 'https://api-dashboard.eilis-ai.com/users/getUserByEmail';
            const postData = {
                Email: payload.email,
                phone: payload.phone
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res;
            })
        },
        setCoadmin({ commit, state }, payload) {
            const apiUrl   = 'https://firebase-member-node.herokuapp.com/users/coadmin';
            const postData = {
                Email: payload.email,
                Service: (payload.service === 'FB') ? 'fb' : 'line',
                Auth: payload.auth,
                AuthName: payload.authName,
                Uid: payload.uid
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res;
            })
        },
        deleteCoadmin({ commit, state }, payload) {
            const apiUrl   = 'https://firebase-member-node.herokuapp.com/users/deleteCoad';
            const postData = {
                Service: (payload.service === 'FB') ? 'fb' : 'line',
                Auth: payload.auth,
                Uid: payload.uid
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res;
            })
        },
        switchAdmin({ commit, state }, payload) {
            const apiUrl   = 'https://firebase-member-node.herokuapp.com/users/switchAdmin';
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                NewAdmin: payload.email
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res;
            })
        },
        // ---------------------------------------------
        // 會員資料區
        getSheetUrl({ commit, state }, payload) {
            const apiUrl   = `https://${member_api}/getSheet`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res;
            })
        },
        changeUserToken({ }, contents) {
            const apiUrl = `https://${member_api}/changeUserToken`;
            return axios.post(apiUrl, contents).then((res) => {
                return res;
            })
        },
        changeUserPhone({ }, contents) {
            const apiUrl = `https://${member_api}/changeUserPhone`;
            return axios.post(apiUrl, contents).then((res) => {
                return res;
            })
        },
        updateUserDetail({ }, contents) {
            const apiUrl = `https://${member_api}/updateUserDetail`;
            return axios.post(apiUrl, contents).then((res) => {
                return res;
            })
        },
        getUserByPhone({ }, contents) {
            const apiUrl = `https://${member_api}/getUserByPhone`;
            return axios.post(apiUrl, contents).then((res) => {
                return res;
            })
        },
        addUserComment({ commit, state }, payload) {
            const apiUrl   = `https://${member_api}/addComment`;
            const postData = {
                service: payload.service,
                auth: payload.auth,
                phone: payload.phone,
                comment: payload.comment
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res;
            })
        },
        getMemberCount({ commit, state }, payload) {
            const apiUrl   = `https://${member_api}/getMemberNum`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res;
            })
        },
        getScript({ commit, state }, payload) {
            const apiUrl   = 'https://api-schedule.eilis-ai.com/functional/getScript';
            const postData = {
                Service: payload.service,
                Auth: payload.auth
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res;
            })
        },
        removeScript({ commit, state }, payload) {
            const apiUrl = 'https://api-schedule.eilis-ai.com/functional/removeScript';
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                ScriptNames: payload.scriptNames
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res;
            })
        },
        SetPageScript({ commit, state }, payload) {
            const apiUrl = 'https://api-schedule.eilis-ai.com/functional/SetPageScript';
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Type: payload.type,
                ScriptName: payload.scriptName,
                Content: payload.content
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res;
            })
        },
        checkWhiteList({}, payload) {
            const apiUrl = `https://${member_api}/checkWhiteList`;
            return axios.post(apiUrl, payload).then((res) => {
                return res.data;
            })
        },
        getUserDetail({}, payload) {
            const apiUrl = 'https://api-dashboard.eilis-ai.com/users/getUserDetail';
            const postData = {
                uid: localStorage.getItem('UserID')
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res;
            })
        },
        userLogin({ state, commit }, payload) {
            const apiUrl = 'https://api-dashboard.eilis-ai.com/users/login';
            return axios.post(apiUrl, payload).then((res) => {
                commit('getUser', res.data);
                return res;
            })
        },
        sendEmail({}, payload) {
            const apiUrl = 'https://api-dashboard.eilis-ai.com/sendResetEmail';
            return axios.post(apiUrl, payload).then((res) => {
                return res;
            })
        },
        changePass({}, payload) {
            const apiUrl = 'https://api-dashboard.eilis-ai.com/users/changePass';
            return axios.post(apiUrl, payload).then((res) => {
                return res;
            })
        },
        sendSMS({ commit, state }, contents) {
            const apiUrl = 'https://louisa-api-server.eilis-ai.com/sendSMS';
            const data = {
                phone: contents.phone, // 起始交易日期
                message: `你的驗證碼為: ${contents.code} (Powered by EILIS)`,
                countryCode: '886'
            };
            return axios.post(apiUrl, data)
                .then((res) => {
                    return res;
                })
        },
        register({ commit, state }, contents) {
            const apiUrl = 'https://firebase-member-node.herokuapp.com/users/signin';
            return axios.post(apiUrl, contents)
                .then((res) => {
                    return res;
                })
        },
        setUserPhone({ commit, state }, payload) {
            const apiUrl = 'https://api-dashboard.eilis-ai.com/users/setUserPhone';
            return axios.post(apiUrl, payload).then((res) => {
                return res;
            })
        },
        // 刪除粉專特定分眾
        removeTagFromAccount({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/removeTagFromAccount`;
            return axios.post(apiUrl, payload).then((res) => {
                return res;
            })
        },
        getRedeemItem({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/api/getRedeemItem`;
            return axios.post(apiUrl, payload).then((res) => {
                return res;
            })
        },
        getAESData({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/api/685498085134680/v1/getAESData`;
            const postData = {
                content: payload.content
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                })
        },
        getGDSData({ }, payload) {
            const apiUrl = 'https://emc-api-server.eilis-ai.com/getGDSData';
            return axios.post(apiUrl, payload).then((res) => {
                return res;
            })
        },
        refreshTagNum({ }, payload) {
            const apiUrl = 'https://emc-api-server.eilis-ai.com/refreshTagNum';
            return axios.post(apiUrl, payload).then((res) => {
                return res;
            })
        }
    },
    mutations: {
        getWorkFlows(state, payload) {
            const auth  = payload.auth;
            const cards = payload.cards;
            state.workFlows[auth] = cards;
        },
        getUser(state, payload) {
            state.uid       = payload.uid;
            state.userName  = payload.displayName;
            state.lastLogin = payload.lastLoginAt;
        },
        getMenus(state, payload) {
            const auth     = payload.auth;
            const menuData = payload.menuData;
            state.menus[auth] = menuData;
        },
        getPageDetail(state, payload) {
            state.pageDetail.name     = payload.name           ? payload.name           : '';
            state.pageDetail.logo     = payload.logo           ? payload.logo           : '';
            state.pageDetail.ratio    = payload.ratio          ? payload.ratio          : 50;
            state.pageDetail.expRatio = payload.expRatio       ? (1 / payload.expRatio) : '';
            state.pageDetail.taxid    = payload.taxid          ? payload.taxid          : '23055068';
            state.pageDetail.undotax  = payload.undotax        ? payload.undotax        : payload.taxid ? payload.taxid : '23055068';
            state.pageDetail.type     = payload.type           ? payload.type           : 'typeC';
            state.pageDetail.store    = state.pageDetail.store ? state.pageDetail.store : {}
        }
    },
});

export default store;